import { Input, Component, Output, EventEmitter } from '@angular/core';
import { Impression } from '../../constants-types/Enums';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { JobFit, Person } from '../../core-data-model/Person.model';
import { notificationOnError } from '../../core-services/Notifications.service';
import { PersonApi } from '../../core-services/PersonApi.connect';

@Component({
    selector: 'candidate-bookmark-toggler',
    template: `
        <abstract-icon
            class="bookmark"
            [iconType]="
                candidate.jobFit?.personImpression === Impression.Favorite
                    ? IconType.BookmarkSelected
                    : IconType.Bookmark
            "
            [iconSize]="IconSize.Large"
            (click)="toggleBookmark($event)"
            style="cursor:pointer"
        ></abstract-icon>
    `,
    styles: [
        `
            .bookmark:hover,
            .bookmark:focus {
                background-color: rgba(216, 214, 220, 1);
                border-radius: 15px;
            }
        `
    ],
    standalone: false
})
export class CandidateBookmarkTogglerComponent {
    IconType = IconType;
    IconSize = IconSize;
    Impression = Impression;

    @Input()
    candidate: Person;

    @Output()
    candidateChange: EventEmitter<Person> = new EventEmitter();

    constructor(private personApi: PersonApi) {}

    @notificationOnError()
    async toggleBookmark(event: MouseEvent) {
        // To stop the click event bubble that would launch the peek panel in the candidate card
        event.preventDefault();
        event.stopPropagation();

        if (this.candidate.jobFit) {
            const selection: Impression =
                this.candidate.jobFit.personImpression === Impression.Favorite
                    ? Impression.Unset
                    : Impression.Favorite;

            /* This is the pattern to update readonly properties on an object
            You would want to Create a new Object with the same properties of old object with the properties you would like to change

            Note:
            The syntax for Object.assign is Object.assign(target,...source)
            https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
            */
            const newJobFit = new JobFit(
                Object.assign({}, this.candidate.jobFit, {
                    personImpression: selection
                })
            );
            this.candidate = this.candidate.updateJobFit(newJobFit);

            await this.personApi.updatePerson(this.candidate.id, {
                impression: selection
            });
            this.candidateChange.emit(this.candidate);
        }
    }
}
